import _ from 'lodash';
import en from './en.json';
import es from './es.json';

export const getCountryName = ( country, area,locale ) => {
  let localeFile = null;
  switch ( locale ) {
    case 'es':
      localeFile = es;
      break;
    default:
      localeFile = en;
  }

  const countryData = _.find( localeFile, { alpha2: country.toLowerCase() } );
  const countryArea = `${countryData.name}`
  // console.log("countryArea",countryArea)

  // const countryArea = `${countryData.name}-${area}`

  const oldCountryArea = `${country}-${area}`
  // console.log("countryArea",countryArea)
  // console.log("countryData",countryData)
  return countryData ? countryArea : oldCountryArea;
};

export const getCountries = ( locale ) => {
  switch ( locale ) {
    case 'es':
      return _.map( es, ( item ) => ( { id: item.alpha2.toUpperCase(), name: item.name } ) );
    default:
      return _.map( en, ( item ) => ( { id: item.alpha2.toUpperCase(), name: item.name } ) );
  }
};


// HARSHIT
export const isCountryUE = ( countryID ) => '|DE|AT|BE|BG|CY|HR|DK|SI|ES|EE|FI|FR|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|CZ|SK|RO|SE|'.indexOf(
  `|${countryID}|`,
) >= 0;
